import type { KnowledgeSyncContract } from '@terra/shared-contracts-knowledge-sync';
import { knowledgeSyncClient } from '@terra/shared-rest-clients-knowledge-sync';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const knowledgeSourcesApi = {
  getAppKnowledgeSummary: (applicationId: string) =>
    tenantAwareApiWrapper<typeof KnowledgeSyncContract.getAppKnowledgeSummary>({
      endpointFn: (headers) =>
        knowledgeSyncClient.getAppKnowledgeSummary({
          params: { applicationId },
          ...withOrchestratorClient(headers),
        }),
    }),

  deleteMapping: (mappingId: string) =>
    tenantAwareApiWrapper<typeof KnowledgeSyncContract.deleteMappings>({
      endpointFn: (headers) =>
        knowledgeSyncClient.deleteMappings({
          params: { mappingId },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
